<template>
  <div class="custom-popover-wrapper-for-ai-tips">
    <Button
      @click.stop="toggle"
      class="custom-button-appearance"
      :pt="customPtButtonStyles"
      rounded
    >
      <template #icon>
          <CustomSvgIcons
            name="scope" :size="20"
            class="scope-icon"
            :color="'var(--active-100)'"
            :class="{
                rotate: op?.visible
             }"
          />
      </template>
    </Button>

    <Popover v-if="deviceType === 'desktop'" ref="op" class="remove-hide-popover-arrow" appendTo="body">
      <div class="ai-tip-capsules-content">
        <slot></slot>
      </div>
    </Popover>

    <Drawer v-else v-model:visible="isDrawerVisible" header=" " class="remove-hide-popover-arrow" position="bottom" style="height:auto" >
      <div class="ai-tip-capsules-content">
        <slot></slot>
      </div>
    </Drawer>
  </div>
</template>

<script setup lang="ts">
import Button from "primevue/button";
import Popover from "primevue/popover";
import Drawer from 'primevue/drawer';

import { computed, ref } from 'vue'
import CustomSvgIcons from '@/components/HelpersComponents/CustomSvgIcons.vue'
import { useDevice } from '@/composables/useDevice'

const { isDevice } = useDevice();
const deviceType = computed(() => isDevice.value);

const op = ref();
const isDrawerVisible = ref(false)

const customPtButtonStyles = {
  root:{
    style:{
      backgroundColor:'rgba(216, 229, 173, 0.8)',
      borderColor:'transparent',
      color:'var(--active-100)',
      width:'10px',
      height:'10px',
      padding:'0',
    }
  }
}

const toggle = (event: Event) => {
  if(deviceType.value === 'desktop') {
    op.value.toggle(event);
  } else {
    isDrawerVisible.value = !isDrawerVisible.value
  }
};
</script>

<style scoped>
:deep(.remove-hide-popover-arrow) {
  top: 50% !important;
  left: 50% !important ;
  transform: translate(0, 15%);
}


:deep(.remove-hide-popover-arrow:before) {
  content:none !important;
}

:deep(.remove-hide-popover-arrow:after) {
  content:none !important;
}

.custom-popover-wrapper-for-ai-tips {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 100000;
}

.ai-tip-capsules-text {
  width: 320px;
  color: rgba(110, 133, 203, 1);
}



.scope-icon {
  display: none;
  transition: transform 0.3s ease;
  transform: scale(0.75);
}


.rotate {
  transform: rotate(45deg) scale(0.75) !important;
}

.custom-button-appearance {
  transition: transform 0.3s ease;
}

.custom-button-appearance:hover {
  transform: scale(4);
}


.custom-button-appearance:hover .scope-icon {
  display: initial;

}

</style>

<style>
.remove-hide-popover-arrow:before {
  content:none !important;
}

.remove-hide-popover-arrow:after {
  content:none !important;
}

</style>
